<template>
    <div class="akmitem" v-bind:id="site.site" :style="{width: cwidth + 'px', height: cwidth + 'px'}">
        <div class="mini" v-if="mode === 'mini'" >
            <img v-bind:src="site.attrs.logo" :class="site.site">
        </div>
    </div>
</template>

<script>
/* eslint-disable */
  import Vue from 'vue'
  export default {
    props: ['cwidth', 'site'],
    name: "akmitem",
    data () {
      return {
        mode: 'mini',
      }
    },
    watch: {
      // 监测mode值的改变，由于mode值没有直接在代码中使用，它的改变不会使component rerender，使用watch实现
      mode: function () {
        if(this.mode === 'mini'){
          this.itemMode = 'mini'
        }
      }
    },
    created(){
    },
    updated:  function () {
    },
    methods: {
    }
  }
</script>

<style lang="less">
    .akmitem{
        /*width: 350px;*/
        /*height: 450px;*/
        /*margin-top: 10px;*/
        /*padding: 0 10px;*/
        background-color: #FFFFFF;
        border-radius: 5px;
        .mini{
            /*padding: 10px 0;*/
            text-align: center;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 50%;
                &.zhihu{
                    width: 50%;
                }
                &.cbo{
                    width: 70%;
                }
                &.qdaily{
                    width: 30%;
                }
            }
        }
    }

</style>